<template>
		<div class="tou">
			<!-- 主文 -->
			<div style="display: flex;justify-content: center;align-items: center;">
				<div>
					<div style="background-color:#F5F5F5;display: flex;">
						<div class="zwk" style="background-color:white;padding:10px 10px 0px 10px;" >
							<div v-for="(item,index) in sb" :key="index">
								<div class="zxls">{{item.name}}</div>
								<div style="padding:5px 0 5px;margin-bottom:10px;">
									<div style="font-size:14px;text-align:left;"></div>
									<div style="display:flex;flex-wrap: wrap;">
										<div v-for="(itemtwo,i) in titles" :key="i" style="display: flex;" @click="tap(i)" class="box_key">
											<a class="kesd" :class="[current==i?'active1':'']" v-if="itemtwo.name&&item.id==itemtwo.pid">{{itemtwo.name}}</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="zwk2" style="background-color:white;padding:10px 10px 0px 10px;">
							<div class="zxls"></div>
							<div>
								<div style="text-align: left;margin-top: 10px;display: flex;">
									<img :src="urls+titlestwo.url" style="width: 516px;height: 262px;" />
									<div class="artitle_media">
										<video  preload controls style="width: 332px;height: 262px;margin-left: 20px;">
										      <source :src="urls+titlestwo.video_url" type="video/mp4" v-if="titlestwo&&titlestwo.video_url" />
										 </video>
									</div>
								</div>
								<!-- <div class="bjtop" style="text-align: left;line-height:30px;">{{titlestwo.info}}</div> -->
								<div v-html="titlestwo.info" style="text-align:left;font-size:14px;" class="imgs"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"About",
		components:{
		},
		data() {
			return {
				url:'https://www.baidu.com/',
				urls:'',
				sb:'',
				id:'',//进入页面默认id0
				pid:[],
				nrid:'',
				titles:'',
				titlestwo:'',
				current:0
			}
		},
		created() {
				//获取业务介绍分类接口
				axios({
				    url: `${base.url}/api/user/businessOne`,
				    method: 'post',
				    data:''
				}).then((res) => {
							if(res){
								this.sb=res.data
								// console.log(this.sb);
								this.urls=res.url
								//map循环添加元素到数组
								res.data.map(item=>{
									this.pid.push(item.id)
								})
								this.nrxx()
							}
				        })
						// //获取业务介绍列表接口
						// axios({
						//     url: `${base.url}/api/user/business`,
						//     method: 'post',
						//     data:{pid:this.id}
						// }).then((res) => {
						// 			if(res){
						// 				this.titles=res.data
						// 				this.titlestwo=res.data[this.id]
						// 				console.log(this.titlestwo);
						// 			}
						//         })
		},
		methods: {
		nrxx:function(){
			//获取业务介绍列表接口
			axios({
			    url: `${base.url}/api/user/business`,
			    method: 'post',
			    data:{pid:this.pid}
			}).then((res) => {
						if(res){
							this.titles=res.data
							if(this.id==''){
								this.id=this.titles[0].id
							}
							this.titles.map(item=>{
								if(item.id==this.id){
									this.titlestwo=item
								}
							})
							// this.titlestwo=res.data[this.id]
						}
			        })
		},
		tap:function(e){
			// console.log(e);
			this.id=this.titles[e].id
			this.current = e;
			this.nrxx()
		},
		},
	}
</script>

<style lang="scss" >
	.imgs{
		img{
			width:100%;
			// height:200rpx;
		}
	}
	.tou{
		background-color:#F5F5F5;
		width:100%;
		height:100%;
	}
	.rightk{
		width:100%;
		height:100px;
		background-color:white;
		.rightk-one{
			font-size:14px;
			display:flex;
			position: absolute;
			right:50px;
		}
		.rightk-two{
			position: absolute;
			right:50px;
			top: 60px;
			display: flex;
		}
		.button-one{
			width:353px;
			height:25px;
			border-style:solid;
			border-width:2px;
			border-color:#20919D;
		}
	}
	.zwk{
		margin:0px 10px 0px 10px;
		width: 240px;
		// height:695px;
		background-color:#ffffff;
	}
	.zwk2{
		width: 890px;
		// height:695px;
		background-color:#ffffff;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.active1{
		color:#20919D!important;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.font{
		font-size:14px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.zxls{
		text-align: left;
		color:#181818;
		font-size:14px;
		font-weight:600;
	}
	.kesd{
		display: inline-block;
		height: 14px;
		line-height: 14px;
		font-size: 14px;
		margin-left:2px;
		margin-top:5px ;
		color:#848484;
		border-right: 1px solid #999;
		padding: 0 5px;
	}
	.kesd:hover{
		cursor:pointer;
		color:#20919D !important;
	}
	.box_key:last-child .kes{
		border: 0;
	}
	.Lines{
		width:1px;
		height: 12px;
		background-color:#CCCCCC;
		margin:10px 5px 10px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
	.artitle_media{
	    text-align: center;
	}
	.artitle_media video{
	    object-fit:fill;
	    width:100%;
	    height:100%;
	    margin-left: auto;
	    margin-right: auto;
		outline:none
	}
</style>
